import { useAppMutation } from "../../../../http/useAppMutation.ts";
import { useWorkspaceUuid } from "../../../hooks/useWorkspaceUuid.ts";

export const useDeleteBrands = () => {
  const workspaceUuid = useWorkspaceUuid();

  const { mutate: deleteBrands, isLoading: isDeletingBrands } = useAppMutation({
    path: `workspaces/${workspaceUuid}/delete-brands/`,
    invalidate: [`workspaces/${workspaceUuid}`],
  }).mutation;

  return {
    deleteBrands: (brandUuids: string[]) =>
      deleteBrands({ brand_uuids: brandUuids }),
    isDeletingBrands,
  };
};
